import SyncSettingsTabOutbound from './syncSettingsTabOutbound.container';

export default SyncSettingsTabOutbound;
